import React, { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../../firebase";
import { useNavigate } from "react-router-dom";
import { Key, ArrowLeft } from "lucide-react";

const ResetPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleReset = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (!email) {
      setError("Please enter your email.");
      return;
    }

    try {
      await sendPasswordResetEmail(auth, email);
      setMessage("Password reset email sent. Please check your inbox.");
    } catch (err: any) {
      const code = err.code;
      if (code === "auth/user-not-found") {
        setError("No user found with this email.");
      } else if (code === "auth/invalid-email") {
        setError("Invalid email address.");
      } else {
        setError("Something went wrong. Please try again.");
      }
    }
  };

  return (
    <div className="flex justify-center items-center h-screen ">
      <form onSubmit={handleReset} className="w-full max-w-md p-10">
        <div className="mb-6 text-center">
          <Key className="w-14 h-14 mx-auto text-blue-600 mb-2 rounded-full p-3 bg-gray-200" />
          <h2 className="text-4xl font-bold text-[#222]">Forgot Password?</h2>
          <p className="text-gray-600">
            No worries, we'll send you reset instruction.
          </p>
        </div>

        {error && <p className="text-red-500 mb-3 text-sm">{error}</p>}
        {message && <p className="text-green-600 mb-3 text-sm">{message}</p>}

        <div className="flex flex-col gap-1 w-full mb-10">
          <label htmlFor="">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            className="w-full p-2 border border-gray-600 mb-4 rounded-md focus:outline-2 focus:border-0 outline-blue-600"
            required
          />
        </div>

        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 cursor-pointer"
        >
          Reset Password
        </button>

        <button
          type="button"
          onClick={() => navigate("/login")}
          className="flex items-center justify-center gap-1 mt-4 text-sm text-gray-600 hover:underline mx-auto cursor-pointer"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Login
        </button>
      </form>
    </div>
  );
};

export default ResetPassword;
